import { supabase } from '@/lib/supabase';

const PRIVATE_BUCKETS = ['task-submissions', 'screenshots', 'campaign-reports'];

// Files in private buckets are opened through a short-lived signed URL
// (admins are allowed to read them by storage policy).
export async function openPrivateFile(value) {
  if (!value) return;
  const popup = window.open('', '_blank');
  let url = value;
  for (const bucket of PRIVATE_BUCKETS) {
    const marker = `/object/public/${bucket}/`;
    const path = value.includes(marker) ? value.split(marker)[1] : value.startsWith(`${bucket}/`) ? value.slice(bucket.length + 1) : null;
    if (path) {
      const { data } = await supabase.storage.from(bucket).createSignedUrl(path.split('?')[0], 600);
      url = data?.signedUrl || null;
      break;
    }
  }
  if (!url) {
    popup?.close();
    return;
  }
  if (popup) popup.location.href = url;
  else window.location.href = url;
}
